import { useTranslation } from 'react-i18next';
import { UI_COLORS } from '../../utils/colors';
import PortalModal, { InfoRow } from './PortalModal';
import { formatDate, formatMoney } from '../portalUtils';

/** Read-only inquiry detail. total:0 is shown as "Pending quotation", not "free". */
const PortalInquiryViewModal = ({ isOpen, onClose, inquiry, loading, statusLabels = {} }) => {
  const { t } = useTranslation();
  const s = t('portal.inquiries', { returnObjects: true });
  const c = t('portal.common', { returnObjects: true });
  const items = Array.isArray(inquiry?.items) ? inquiry.items : [];
  const statusText = inquiry?.status ? (statusLabels[inquiry.status] || inquiry.status) : '';

  const totalDisplay = Number(inquiry?.total) > 0 ? formatMoney(inquiry.total) : (s?.pendingQuote || 'Pending quotation');

  return (
    <PortalModal
      isOpen={isOpen}
      onClose={onClose}
      loading={loading}
      title={`${s?.detailTitle || 'Inquiry'} #${inquiry?.id || ''}`.trim()}
      maxWidth="max-w-3xl"
    >
      {inquiry && (
        <div className="space-y-6">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <InfoRow label={s?.columns?.status || 'Status'} value={statusText} />
            <InfoRow label={s?.columns?.created || 'Created'} value={formatDate(inquiry.created_at)} />
            <InfoRow label={s?.columns?.deliveryLocation || 'Delivery Location'} value={inquiry.delivery_location_name} />
            <InfoRow label={s?.columns?.expectedDelivery || 'Expected Delivery'} value={formatDate(inquiry.expected_delivery_date)} />
            <InfoRow label={s?.columns?.total || 'Total'} value={totalDisplay} />
            <InfoRow label={c?.remark || 'Remark'} value={inquiry.remark} />
          </div>

          <div>
            <h3 className="text-sm font-bold mb-2" style={{ color: UI_COLORS.TEXT.PRIMARY }}>{c?.items || 'Items'}</h3>
            <div className="overflow-x-auto rounded-lg border" style={{ borderColor: UI_COLORS.BORDERS.LIGHT }}>
              <table className="w-full text-sm">
                <thead>
                  <tr style={{ backgroundColor: UI_COLORS.BACKGROUNDS.SECTION }}>
                    <th className="text-left px-3 py-2 font-semibold">{c?.product || 'Product'}</th>
                    <th className="text-right px-3 py-2 font-semibold">{c?.quantity || 'Qty'}</th>
                  </tr>
                </thead>
                <tbody>
                  {items.length === 0 ? (
                    <tr><td colSpan={2} className="px-3 py-4 text-center" style={{ color: UI_COLORS.TEXT.MUTED }}>{c?.noItems || 'No items'}</td></tr>
                  ) : items.map((it, i) => (
                    <tr key={i} className="border-t" style={{ borderColor: UI_COLORS.BORDERS.LIGHT }}>
                      <td className="px-3 py-2">{it.product_name || it.product_alias || '—'}</td>
                      <td className="px-3 py-2 text-right">{it.quantity} {it.units || it.unit || ''}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </PortalModal>
  );
};

export default PortalInquiryViewModal;
